/* Vario Racing – collection sidebar: load sub-categories without page reload */
(function () {
  'use strict';
  if (window.__vrfCollInit) return;
  window.__vrfCollInit = true;
  var ctrl = null;

  function bannerEl() {
    return document.querySelector('#MainContent [id^="shopify-section-"][id$="__banner"]');
  }

  function load(url, push) {
    var root = document.querySelector('[data-vrf-coll]');
    if (!root) { window.location.href = url; return; }
    var main = root.querySelector('[data-vrf-coll-main]');
    var side = root.querySelector('.vrf-coll__side');
    var gridId = root.getAttribute('data-section');
    var banner = bannerEl();
    var bannerId = banner ? banner.id.replace('shopify-section-', '') : null;
    var u = new URL(url, window.location.origin);
    u.searchParams.set('sections', bannerId ? gridId + ',' + bannerId : gridId);
    if (ctrl) ctrl.abort();
    ctrl = 'AbortController' in window ? new AbortController() : null;
    root.classList.add('is-loading');

    fetch(u.toString(), ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data[gridId] || '';
        var nroot = tmp.querySelector('[data-vrf-coll]');
        if (!nroot) throw new Error('no section');
        side.innerHTML = nroot.querySelector('.vrf-coll__side').innerHTML;
        main.innerHTML = nroot.querySelector('[data-vrf-coll-main]').innerHTML;
        if (banner && data[bannerId]) {
          var b = document.createElement('div');
          b.innerHTML = data[bannerId];
          var nb = b.querySelector('#shopify-section-' + CSS.escape(bannerId)) || b.firstElementChild;
          if (nb) banner.replaceWith(nb);
        }
        if (push) history.pushState({ vrfColl: true, searchParams: '' }, '', url);
        document.dispatchEvent(new CustomEvent('vrf:collection-swap'));
        var act = root.querySelector('.vrf-coll__link.is-active');
        if (act) document.title = act.getAttribute('data-title') + ' – ' + (root.getAttribute('data-shop') || '');
        root.classList.remove('is-loading');
        main.classList.remove('vrf-in'); void main.offsetWidth; main.classList.add('vrf-in');
        var anchor = bannerEl() || root;
        var top = anchor.getBoundingClientRect().top + window.scrollY - 70;
        if (window.scrollY > top + 40) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        var a = side.querySelector('.vrf-coll__link.is-active');
        if (a && a.scrollIntoView && window.matchMedia('(max-width: 989px)').matches) a.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-vrf-ajax]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!document.querySelector('[data-vrf-coll]')) return;
    e.preventDefault();
    if (a.classList.contains('is-active')) return;
    var side = a.closest('.vrf-coll__side');
    if (side) {
      side.querySelectorAll('.vrf-coll__link.is-active').forEach(function (x) { x.classList.remove('is-active'); });
      a.classList.add('is-active');
    }
    load(a.href, true);
  });

  window.addEventListener('popstate', function () {
    if (document.querySelector('[data-vrf-coll]')) load(window.location.href, false);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var a = document.querySelector('[data-vrf-coll] .vrf-coll__side > .vrf-coll__list .vrf-coll__link.is-active');
    if (a && window.matchMedia('(max-width: 989px)').matches) {
      var list = a.closest('.vrf-coll__list');
      list.scrollLeft = a.offsetLeft - list.clientWidth / 2 + a.clientWidth / 2;
    }
  });
})();
